export const StateChanges = {
    SET_DIRECT_RESULTS: 'SET_DIRECT_RESULTS',
    SET_TEXT_FOR_API_CALL: 'SET_TEXT_FOR_API_CALL',
    SET_VISUALIZER: 'SET_VISUALIZER',
    SET_MIN_RANGE: 'SET_MIN_RANGE',
    SET_MAX_RANGE: 'SET_MAX_RANGE',
    SET_MODE: 'SET_MODE',
    SET_DATA: 'SET_DATA',
    SET_ALL_RESULTS: 'SET_ALL_RESULTS',
    SET_SELECTED_RESULTS: 'SET_SELECTED_RESULTS',
    SET_TALMUD_RESULTS: 'SET_TALMUD_RESULTS',
    SET_MISHNA_RESULTS: 'SET_MISHNA_RESULTS',
    SET_TANAKH_RESULTS: 'SET_TANAKH_RESULTS',
    SET_FOOTNOTE_RESULTS: 'SET_FOOTNOTE_RESULTS',
    SET_VERSE_FOR_CHAPTER: 'SET_VERSE_FOR_CHAPTER',
    SET_CHAPTER_RESULTS: 'SET_CHAPTER_RESULTS',
    SET_VISUALIZER_RESULTS: 'SET_VISUALIZER_RESULTS',
    SET_VISUALIZER_MODE: 'SET_VISUALIZER_MODE',
    SET_NO_RESULTS: 'SET_NO_RESULTS',
    SET_HIGHER_THRESHOLD_RESULTS: 'SET_HIGHER_THRESHOLD_RESULTS',
    SET_LOWER_THRESHOLD_RESULTS: 'SET_LOWER_THRESHOLD_RESULTS',
    SET_EXTERNAL_TALMUD_RESULTS: 'SET_EXTERNAL_TALMUD_RESULTS',
    SET_EXTERNAL_TANAKH_RESULTS: 'SET_EXTERNAL_TANAKH_RESULTS',
    FOOTNOTES_COMPLETE: 'FOOTNOTES_COMPLETE',
    SET_SERVER_ERROR: 'SET_SERVER_ERROR'
  }
  
  export const Actions = {
    RUN_FOOTNOTES: 'RUN_FOOTNOTES',
    RUN_VISUALIZER: 'RUN_VISUALIZER',
    RUN_CHAPTERS: 'RUN_CHAPTERS',
    RUN_PARSE: 'RUN_PARSE',
    DOWNLOAD_RESULTS: 'DOWNLOAD_RESULTS',
    RUN_TANAKH_SEARCH: 'RUN_TANAKH_SEARCH',
    RUN_TALMUD_SEARCH: 'RUN_TALMUD_SEARCH'
  }